import { EVENT_CLICK } from "@splidejs/splide"

{
  const container = () => document.querySelector('.page-sidebar-menu')
  const menuClassname = 'menu'

  const menu = el => el.querySelector(':scope > .menu')
  const rect = el => el.getBoundingClientRect()
  const height = el => `${rect(menu(el)).height}px`
  const auto = el => { menu(el).style.height = 'auto'; }
  const hide = el => { menu(el).setAttribute('inert', 'inert');  menu(el).style.height = '0px'; el.classList.remove('show')}
  const show = (el, h) => { menu(el).removeAttribute('inert');  menu(el).style.height = h; el.classList.add('show')}

  const toggle = el => {
    if (!el.classList.contains('menu-item__in-path')) {
      if (el.classList.contains('show')) {
        collapse(el)
      } else {
        expand(el)
      }
    }
  }

  const expand = el => {
    auto(el)
    let h = height(el);
    hide(el)
    setTimeout(() => show(el,h), 1)
  }

  const collapse = el => {
    auto(el)
    let h = height(el);
    show(el, h)
    setTimeout(() => hide(el), 1)
  }


  const onClick = (e) => {
    let after = true
    const _item = e.target.closest('.menu-item')
    const _link = e.target.closest('a')
    const _submenu = e.target.closest('.menu')
    
    if (!_item || _item.contains(_link) || _item.contains(_submenu)) {
      after = false
    }
    
    if (after) {
      e.preventDefault()
      toggle(_item)
    }
  }

  document.addEventListener('click', onClick)

}